import { useEffect, useState } from "react";

const ALERTS_KEY = "jobzilla_candidate_job_alerts";

function CanJobAlertsPage() {
    const [alerts, setAlerts] = useState([]);
    const [form, setForm] = useState({ keyword: "", location: "", frequency: "daily" });
    const [message, setMessage] = useState("");

    useEffect(() => {
        const stored = localStorage.getItem(ALERTS_KEY);
        if (stored) setAlerts(JSON.parse(stored));
    }, []);

    const persist = (items) => {
        setAlerts(items);
        localStorage.setItem(ALERTS_KEY, JSON.stringify(items));
    };

    const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });

    const add = (event) => {
        event.preventDefault();
        if (!form.keyword && !form.location) {
            setMessage("Add a keyword or location for the alert.");
            return;
        }
        persist([{ ...form, id: `alert_${Date.now()}`, created_at: new Date().toISOString(), active: true }, ...alerts]);
        setForm({ keyword: "", location: "", frequency: "daily" });
        setMessage("Job alert created.");
    };

    const toggle = (id) => {
        persist(alerts.map((alert) => alert.id === id ? { ...alert, active: !alert.active } : alert));
    };

    const remove = (id) => {
        persist(alerts.filter((alert) => alert.id !== id));
        setMessage("Job alert deleted.");
    };

    return (
        <div className="twm-right-section-panel candidate-save-job site-bg-gray">
            <div className="product-filter-wrap d-flex justify-content-between align-items-center">
                <span className="woocommerce-result-count-left">Job Alerts</span>
            </div>
            {message && <div className="alert alert-info">{message}</div>}
            <form onSubmit={add} className="panel panel-default p-a20 m-b30">
                <div className="row">
                    <Field label="Keyword" name="keyword" value={form.keyword} onChange={update} />
                    <Field label="Location" name="location" value={form.location} onChange={update} />
                    <div className="col-md-3">
                        <label>Frequency</label>
                        <select className="form-control" name="frequency" value={form.frequency} onChange={update}>
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                        </select>
                    </div>
                    <div className="col-md-3 d-flex align-items-end">
                        <button type="submit" className="site-button">Create Alert</button>
                    </div>
                </div>
            </form>
            <div className="table-responsive">
                <table className="table twm-table table-striped table-borderless">
                    <thead>
                        <tr><th>Keyword</th><th>Location</th><th>Frequency</th><th>Status</th><th>Created</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                        {alerts.length === 0 ? (
                            <tr><td colSpan={6} className="text-center">No job alerts yet.</td></tr>
                        ) : alerts.map((alert) => (
                            <tr key={alert.id}>
                                <td>{alert.keyword || "Any"}</td>
                                <td>{alert.location || "Any"}</td>
                                <td>{alert.frequency}</td>
                                <td>{alert.active ? "Active" : "Paused"}</td>
                                <td>{new Date(alert.created_at).toLocaleDateString()}</td>
                                <td>
                                    <button type="button" className="site-button-link site-text-primary m-r10" onClick={() => toggle(alert.id)}>{alert.active ? "Pause" : "Activate"}</button>
                                    <button type="button" className="site-button-link site-text-primary" onClick={() => remove(alert.id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

function Field({ label, name, value, onChange }) {
    return (
        <div className="col-md-3">
            <label>{label}</label>
            <input className="form-control" name={name} value={value} onChange={onChange} placeholder={label} />
        </div>
    );
}

export default CanJobAlertsPage;
